import React from 'react'
import style from './Loader.module.scss'

export default function Loader() {
  return (
    <div className={style.loaderWrap}>
        <span class={style.loader}></span>
    </div>
  )
}
